import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { UtilsService } from '../../../services/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { OrganizationsService } from '../../../services/organizations.service';
import { GuidesService } from '../../../services/guides.service';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-organization-view',
  templateUrl: './organization-view.component.html',
  styleUrls: ['./organization-view.component.scss']
})

export class OrganizationViewComponent {

  modelChanged: Subject<string> = new Subject<string>();

  organization = {};
  guides = [];
  guideMapById = {};

  selectedFiles: FileList;

  constructor(private graphqlService: OrganizationsService,
              private guideService: GuidesService,
              private utilsService: UtilsService,
              private router: Router,
              private route: ActivatedRoute) {

    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateOrganization());

    route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];

        this.graphqlService.read(id).subscribe(result => {
          if (result && result.data) {
            this.organization = JSON.parse(JSON.stringify(result.data['organization']));
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });
        this.guideService.getAllGuides().subscribe(result => {
          if (result && result.data) {
            this.guides = result.data['guides'].items;
            const that = this;
            this.guides.forEach(function (guide) {
              that.guideMapById[guide.id] = guide;
            });
          }
        });
      }
    });
  }

  dataChanged() {
    this.modelChanged.next();
  }


  updateOrganization() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.organization['name']);
    if (requiredSuccess) {
      this.graphqlService.update(this.organization).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Organization Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update Organization.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  upload() {
    /* const file = this.selectedFiles.item(0);
     this.uploadService.uploadfile(file, function (err, data) {
       if (err) {
         console.log('There was an error uploading your file: ', err);
         return false;
       }

       console.log('Successfully uploaded file.', data);
     });*/
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  deleteOrganization() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.organization).subscribe(({data}) => {
      this.utilsService.openSnackBar('Organization Deleted !!', '');
      this.router.navigate(['/organizations']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete organization.', '');
      console.log('there was an error sending the query', error);
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/organizations/organization-view/organization-view.component.ts